import PropTypes from 'prop-types';

const sharedProps = {
  /** Buttons to render in the footer */
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func,
      text: PropTypes.string,
      'data-autofocus': PropTypes.bool,
    }),
  ),
  appearance: PropTypes.oneOf(['primary', 'success', 'danger', 'warning', 'info']),
  autoFocus: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['sm', 'md', 'lg', 'x-lg', 'fill'])]),
};

export default sharedProps;
